//#region Imports
import { useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import '../../../../scss/Components/_modal.scss';
import customAxios from '../../../../utils/customAxios';
import { GlobalVariables } from '../../../../globalVar';
import { getToast } from '../../../../utils/toastConfig';

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

const CreateClientTiModal = ({ show, onHide, getData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [position, setPosition] = useState('');

  const resetFormFields = () => {
    setName('');
    setLastName('');
    setEmail('');
    setNumber('');
    setPosition('');
  };

  const createClientTi = async (event) => {
    event.preventDefault();

    if (!name || name.trim().length === 0) {
      getToast({
        status: 'error',
        title: 'El nombre del Contacto de Sucursal no puede estar vacío.',
      });
      return;
    }

    if (!lastName || lastName.trim().length === 0) {
      getToast({
        status: 'error',
        title: 'El apellido del Contacto de Sucursal no puede estar vacío.',
      });
      return;
    }

    if (!email || email.trim().length === 0) {
      getToast({
        status: 'error',
        title: 'El correo del Contacto de Sucursal no puede estar vacío.',
      });
      return;
    }

    setIsLoading(true);

    try {
      const endpoint = `${GlobalVariables.getURL()}client-ti/createClientTi`;
      const response = await customAxios.post(
        endpoint,
        {
          name: name.trim(),
          last_name: lastName.trim(),
          email: email.trim(),
          number: number.trim() ? Number(number.trim()) : null,
          position: position.trim(),
        },
        HEADERS,
      );
      console.log(response, ' response');

      if (response.status === 201) {
        hide();
        getData();
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title:
          error.response?.data?.message ||
          'Error al crear Contacto de Sucursal. Vuelve a intentarlo.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const hide = () => {
    onHide();
    getToast({
      status: 'success',
      title: 'Contacto de Sucursal creado exitosamente en la base de datos.',
    });
    resetFormFields();
  };

  const handleClose = () => {
    onHide();
    resetFormFields();
  };

  return (
    <Dialog open={show} maxWidth="md" fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className="inventory-movmodal-title">
          Nuevo Contacto de Sucursal
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 20,
          top: 20,
          width: 40,
          height: 40,
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <form id="site-form" onSubmit={createClientTi}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nombre (s)"
                placeholder="Nombre (s)..."
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Apellido (s)"
                placeholder="Apellido (s)..."
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Correo Electrónico"
                placeholder="Correo Electrónico..."
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Número"
                placeholder="Número..."
                type="number"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Puesto"
                placeholder="Puesto..."
                type="text"
                value={position}
                onChange={(e) => setPosition(e.target.value)}
                required
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          form="site-form"
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size="2rem" />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateClientTiModal;
